import React, { useState, useEffect } from "react";
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import './General.css'

function ShowImage({ image, open, setOpen }) {
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: "popImage",
            }}
            focusTrapped={false}
        >
            <div className="image" >
                <img src={image} /> 
            </div>
        </RModal>
    )
}

export default ShowImage